import Config from "./config.json";

export const apiURL: string = (
    Config.API_URL ? Config.API_URL : window.location.origin
) as string;
export const appURL: string = window.location.origin;
